<template>
<div class="container">
<mt-navbar v-model="selected">
  <mt-tab-item id="1" @click="setid(1)">全部</mt-tab-item>
  <mt-tab-item id="2" @click="setid(2)">待付款</mt-tab-item>
  <mt-tab-item id="3" @click="setid(3)">待预约</mt-tab-item>
</mt-navbar>


<!-- tab-container -->
<mt-loadmore :bottom-method="loadBottom" :auto-fill="false" :bottom-all-loaded="allLoaded" ref="loadmore">

<mt-tab-container v-model="selected" class="mylist">
  <mt-tab-container-item :id="i" v-for="(item,i) in all" :key="item.id">

<div class="row center empty" v-show="!item||item.length==0">
	<i class="fa fa-shopping-cart"></i>
	<p>暂无订单</p>
</div>

   <template v-if="item.length>0">
     <template v-for="(v,i) in item">
   	 <div class="row header"  :key="v.order_code">
	   	 <div class="col-9">订单号：{{v.order_code}}</div>
	   	 <div class="col-1 tr"><i class="fa fa-trash-o" v-show="v.status==1" @click="del(v,i)"></i></div>
   	 </div>

   	 <div :class="{row:true,gooditem:i<v.child.length-1}" v-for="(vv,i) in v.child" v-if="v.child.length>0">
   	 	<div class="col-3">
   	 		<router-link :to="'/mall/detail/ucode/'+vv.gucode">
   	 		 	<img :src="picurl+vv.big_pic" :alt="vv.name">
   	 		</router-link>
   	 	</div>
   	 	<div class="col-7">
   	 		<h4>
	   	 		<router-link :to="'/mall/detail/ucode/'+vv.gucode">{{vv.name}} 
	   	 			<span v-show="vv.attrs>1">({{vv.attr_value}})</span>
	   	 		</router-link>
   	 		</h4>
   	 		<p class="num">
   	 			<span>数量×{{vv.gnum}}</span>
   	 			<span>可预约 {{vv.suitnum*vv.gnum}}</span>
   	 			<span>已预约 {{vv.hadorder}}</span>
   	 		</p>	
   	 		<p class="price">¥
   	 		<span class="price" v-show="vv.paytime>0">{{vv.payprice/100}}</span>
   	 		<span class="price" v-show="vv.paytime==0&&vv.newprice==vv.price">{{vv.newprice/100}}</span>
   	 		<span class="price" v-show="vv.paytime==0&&vv.newprice!=vv.price">{{vv.newprice/100}}</span>
   	 		</p>
   	 	</div>
   	 </div>

   	 <div class="row footer">
   	 	<div class="col">
	   	 	<span v-show="v.paytime==0">{{v.time|date}}</span>
	   	 	<span v-show="v.paytime>0">{{v.paytime|date}}</span>
   	 	</div>
   	 	<div class="colr pbtn">
	   	 	<mt-button size="small" type="danger" v-show="v.status==1" @click="link('/user/buy/'+v.order_code)">立即支付</mt-button>
	        <mt-button size="small" class="btn-blue" v-show="v.status==2" @click="link('/user/person/'+v.order_code)">立即预约</mt-button>
	        <mt-button size="small" class="hadorder" disabled v-show="v.status==3">已预约</mt-button>
	        <span v-show="v.status==4">已删除</span>
   	 	</div>
   	 	<div class="colr mr"><span class="black">合计：</span><b class="price">¥ <span class="price">{{v.allprice/100}}</span></b></div>
   	 	
   	 </div>
    </template>
   </template>
  </mt-tab-container-item>

</mt-tab-container>
</mt-loadmore> <!-- loadmore -->
</div>
</template>

<style scoped>
.row{
    width:100%;
}
.mr{margin-right:1rem;}
.tr{text-align: right;padding-right: .5rem;}
.colr{float:right;}
.center{text-align: center;}
.mylist{margin-top: 1rem;}
.container{background: rgb(251,251,251);color:#adadad;}
.gray{color:#adadad;}
.header{padding:.5rem;background: white;}	
.footer{background: white;margin-bottom: 1rem;height:2.5rem;line-height:2.5rem;padding-left: .5rem;}
.pbtn{padding:0;text-align: right;}
.mint-button--small{border-radius:0;background: red;height:2.5rem;line-height: 2.5rem;}
.btn-blue{color:white;background: rgb(0,144,255);}
.hadorder{background: green;color:white;}
.gooditem{border-bottom:.3rem solid white;}
h4{font-weight: 500;color:black;height:58px;overflow: hidden;}
p{padding:.2rem .5rem;}
.num span{margin-right: 1rem;}
.price{color:red;font-weight: 500;}
span.price{font-size: 1.3rem;}
.black{color:black;}
img{margin:8%;width:84%;}
</style>

<script>

export default {
	data:function(){
		return {
			mydata:mydata,
			picurl:picurl,
			selected:"1",
			all:{
				1:"",
				2:"",
				3:""
			},
			finish:{
				1:false,
				2:false,
				3:false
			},
			allLoaded:false,
			link:fun.link,
		}
	},
	created:function(){
        this.init();
	},
	methods:{
		init:function(){
		   this.$emit("setTitle","我的订单");
		   var id=this.$route.params.id;
		   this.selected=id.toString();
		   this.getall();
		},
		getall:function(){
			var _this=this;
			fun.post(mydata.apiuser+"getorder",{},function(d){
				console.log(d);
				if(d.status==1){
					_this.all=d.info;
				}else{
					_this.$toast(d.info);
				}
			})
		},
        isfinished:function(){
          if(this.finish[1]&&this.finish[2]&&this.finish[3]){return true;}
          return false;
        },
		loadBottom:function(){
			if(this.finish[this.selected]){
				this.$refs.loadmore.onBottomLoaded();
				this.$toast("没有更多了");
				return false;
			}
			this.getorder(this.selected,this.all[this.selected].length);
		},
		getorder:function(type,start){
          var _this=this;
          var data={
            type:type,
            start:start?start:0,
          };
          fun.post(mydata.apiuser+"order_more",data,function(d){
          	//console.log(d);
          	_this.$refs.loadmore.onBottomLoaded();//完成刷新
          	if(d.status==1){
               _this.all[type]=_this.all[type].concat(d.info);
               if(d.info.length<10){_this.finish[type]=true;}
          	}else{
          		_this.$toast(d.info);
          		_this.finish[type]=true;
          	}
          	_this.allLoaded=_this.isfinished()?true:false;
          })
		},
		del:function(v,i){
			var _this=this;
			this.$messagebox.confirm("确定删除该订单吗？").then(function(){
			 fun.post(mydata.apiuser+"del_order",v,function(d){
			 	console.log(d);
			 	if(d.status==1){
                 _this.all[_this.selected].splice(i,1);
			 	}
			 })
			},function(){
				console.log("不删除");
			})
		},
		toorder:function(id){
		  this.$router.push("/user/person/"+id);
		}
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/user/myorder.vue